<template>
  <div class="form-group" style="position: relative">
    <label :for="id" class="">{{ $t("message.reg_form.password") }}</label>
    <input
      :type="is_visible ? 'text' : 'password'"
      :placeholder="placeholder"
      v-model="value_"
      :id="id"
      :style="xstyle"
      :autocomplete="autocomplete"
      class="form-control"
    />

    <button
      style="position: absolute; right: 15px; top: 15px"
      class="btn btn-link btn-sec p-0"
      @click.prevent.stop="toggle"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.44089 12.753C4.3233 12.5709 4.22417 12.4087 4.14393 12.2727C4.22417 12.1368 4.3233 11.9746 4.44089 11.7925C4.81384 11.2151 5.36589 10.4476 6.08181 9.68396C7.53188 8.13722 9.53587 6.72729 12 6.72729C14.4641 6.72729 16.4681 8.13722 17.9182 9.68396C18.6341 10.4476 19.1862 11.2151 19.5591 11.7925C19.6767 11.9746 19.7758 12.1368 19.8561 12.2727C19.7758 12.4087 19.6767 12.5709 19.5591 12.753C19.1862 13.3304 18.6341 14.0979 17.9182 14.8615C16.4681 16.4083 14.4641 17.8182 12 17.8182C9.53587 17.8182 7.53188 16.4083 6.08181 14.8615C5.36589 14.0979 4.81384 13.3304 4.44089 12.753ZM21.8941 11.8248C21.8943 11.8252 21.8944 11.8255 21 12.2727C21.8944 12.72 21.8943 12.7203 21.8941 12.7207L21.8937 12.7215L21.8926 12.7236L21.8895 12.7297L21.8798 12.7488C21.8717 12.7646 21.8603 12.7864 21.8457 12.814C21.8166 12.8691 21.7745 12.9469 21.7198 13.0443C21.6103 13.2388 21.4496 13.5121 21.2392 13.838C20.8195 14.4878 20.1954 15.3567 19.3773 16.2294C17.7592 17.9554 15.2631 19.8182 12 19.8182C8.73686 19.8182 6.24084 17.9554 4.62274 16.2294C3.80456 15.3567 3.18047 14.4878 2.76081 13.838C2.55036 13.5121 2.38968 13.2388 2.28024 13.0443C2.22547 12.9469 2.18342 12.8691 2.15428 12.814C2.1397 12.7864 2.12834 12.7646 2.12021 12.7488L2.11046 12.7297L2.10741 12.7236L2.10634 12.7215L2.10592 12.7207C2.10574 12.7203 2.10557 12.72 3 12.2727C2.10557 11.8255 2.10574 11.8252 2.10592 11.8248L2.10634 11.824L2.10741 11.8219L2.11046 11.8158L2.12021 11.7967C2.12834 11.7809 2.1397 11.7591 2.15428 11.7315C2.18342 11.6764 2.22547 11.5986 2.28024 11.5012C2.38968 11.3067 2.55036 11.0334 2.76081 10.7075C3.18047 10.0577 3.80456 9.1888 4.62274 8.31608C6.24084 6.5901 8.73686 4.72729 12 4.72729C15.2631 4.72729 17.7592 6.5901 19.3773 8.31608C20.1954 9.1888 20.8195 10.0577 21.2392 10.7075C21.4496 11.0334 21.6103 11.3067 21.7198 11.5012C21.7745 11.5986 21.8166 11.6764 21.8457 11.7315C21.8603 11.7591 21.8717 11.7809 21.8798 11.7967L21.8895 11.8158L21.8926 11.8219L21.8937 11.824L21.8941 11.8248ZM21 12.2727L21.8944 11.8255C22.0352 12.1071 22.0352 12.4384 21.8944 12.72L21 12.2727ZM2.10557 11.8255L3 12.2727L2.10557 12.72C1.96481 12.4384 1.96481 12.1071 2.10557 11.8255ZM10.5454 12.2727C10.5454 11.4693 11.1966 10.8181 12 10.8181C12.8033 10.8181 13.4545 11.4693 13.4545 12.2727C13.4545 13.076 12.8033 13.7272 12 13.7272C11.1966 13.7272 10.5454 13.076 10.5454 12.2727ZM12 8.81812C10.0921 8.81812 8.54541 10.3648 8.54541 12.2727C8.54541 14.1806 10.0921 15.7272 12 15.7272C13.9078 15.7272 15.4545 14.1806 15.4545 12.2727C15.4545 10.3648 13.9078 8.81812 12 8.81812Z"
          :fill="is_visible ? '#097CB1' : '#797980'"
        />
      </svg>
    </button>
  </div>
</template>
<script>
export default {
  name: "password",
  props: {
    value: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    label: { type: String, default: "" },
    id: { type: String, default: "" },
    xstyle: { type: String },
    autocomplete: { type: String },
  },
  data() {
    return {
      value_: "",
      is_visible: false,
    };
  },
  mounted() {
    this.value_ = this.value;
  },
  methods: {
    toggle() {
      this.is_visible = !this.is_visible;
    },
  },
  watch: {
    value_() {
      this.$emit("input", this.value_);
    },
    value() {
      this.value_ = this.value;
    },
  },
};
</script>
<style scoped>
.form-group {
  position: relative;
  /* border: 1px solid #B1B1B1; */
  border-radius: 4px;
  height: 56px;
  margin-top: 20px;
  /* margin-bottom: 36px; */
}
.form-group.textarea {
  height: 112px;
}
.form-group .form-control {
  border: 0;
  height: 50px;
  position: absolute;
  box-shadow: none !important;
  outline: none !important;
}
.form-group {
  position: relative;
  margin-top: 20px;
  /* margin-bottom: 36px; */
  height: 56px;
}

.form-group.textarea {
  height: 112px;
}
.form-group .form-control {
  border: 0;
  height: 50px;
  position: absolute;
  box-shadow: none !important;
  outline: none !important;
  border: 1px solid #b1b1b1;
  border-radius: 4px;
  height: 56px;
}

.form-group .form-control:hover {
  border-color: #333333;
}
.form-group .form-control:focus {
  border-color: var(--color2);
}
.form-group textarea.form-control {
  height: 104px;
}
.form-group label {
  font-family: "Roboto";
  padding: 0 4px;
  background-color: #fff;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  position: absolute;
  left: 16px;
  z-index: 3;
  top: -8px;
  /* identical to box height, or 133% */

  /* neutral/30 */

  color: #797980;
}
.btn-sec svg {
  fill: #b1b1b1;
}
.btn-sec:hover svg {
  fill: #797980;
}
</style>
